import type { AttributeObjectType } from "../types/types.PIM";

// Attribute object_types that are structural identifiers and must never be editable.
export const STRUCTURAL_IDENTIFIER_OBJECT_TYPES = new Set<AttributeObjectType>([
  "product_id",
  "sku_id",
  "customer_id",
  "distributor_id",
  "supplier_id",
]);

export const HIDEABLE_IDENTIFIER_OBJECT_TYPES = new Set<AttributeObjectType>([
  "sku_id",
]);

export const NAME_OBJECT_TYPES = new Set<AttributeObjectType>([
  "product_name",
  "company_name",
]);

export const isStructuralIdentifierObjectType = (
  objectType: AttributeObjectType | null | undefined
): boolean =>
  Boolean(objectType && STRUCTURAL_IDENTIFIER_OBJECT_TYPES.has(objectType));

export const isHideableIdentifierObjectType = (
  objectType: AttributeObjectType | null | undefined
): boolean =>
  Boolean(objectType && HIDEABLE_IDENTIFIER_OBJECT_TYPES.has(objectType));

export const isNameObjectType = (
  objectType: AttributeObjectType | null | undefined
): boolean => Boolean(objectType && NAME_OBJECT_TYPES.has(objectType));

// Returns true when an attribute is always visible and cannot be hidden per-view:
// non-hideable structural identifiers (product_id, customer_id, etc.) and
// name-type attributes (product_name, company_name).
export const isAlwaysVisibleObjectType = (
  objectType: AttributeObjectType | null | undefined
): boolean =>
  (isStructuralIdentifierObjectType(objectType) &&
    !isHideableIdentifierObjectType(objectType)) ||
  isNameObjectType(objectType);
